 document.addEventListener('DOMContentLoaded', function() {
    const megaMenus = document.querySelectorAll('.mega-menu');

    megaMenus.forEach(megaMenu => {
      const content = megaMenu.querySelector('.mega-menu__content');
      
      let timeout;

      // Mouse enter event on the summary element
      megaMenu.addEventListener('mouseenter', function() {
        clearTimeout(timeout);
        this.setAttribute('open', '');
      });

      // Mouse leave event on the mega-menu
      megaMenu.addEventListener('mouseleave', function() {
        timeout = setTimeout(() => {
          if (!this.contains(document.activeElement)) {
            this.removeAttribute('open');
          }
        }, 200); // Delay to prevent immediate closing
      });

      // Ensure the mega-menu stays open when moving between the summary and the content area
      content.addEventListener('mouseenter', function() {
        clearTimeout(timeout);
        megaMenu.setAttribute('open', '');
      });

      content.addEventListener('mouseleave', function() {
        timeout = setTimeout(() => {
          megaMenu.removeAttribute('open');
        }, 200); // Delay to allow for content interaction
      });
    });
  });